import { TKey } from "@/app/translations/TKey";
import { FooterSection } from "@/app/types/navigation/FooterSection";
import { LegalPaths, PublicPaths } from "@/app/vars/Routes";

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    titleKey: TKey.FOOTER_RESOURCES,
    links: [{ path: PublicPaths.BLOG, labelKey: TKey.BLOG_NAV_LABEL }],
  },
  {
    titleKey: TKey.FOOTER_LEGAL,
    links: [
      { path: LegalPaths.TERMS, labelKey: TKey.TERMS },
      { path: LegalPaths.PRIVACY, labelKey: TKey.PRIVACY },
    ],
  },
];
